module.exports = __webpack_public_path__ + "img/761.1cb10aa4.jpg";